import { createRouter, createWebHistory } from 'vue-router';
import Index from '../views/Index.vue';
import Trzfw from '../views/Trzfw.vue';
import Zhyq from '../views/Zhyq.vue';
import Wyrz from '../views/Wyrz.vue';
import Cgzy from '../views/Cgzy.vue';
import Cyds from '../views/Cyds.vue';
import CydsDetail from '../views/CydsDetail.vue';
import Jsjlr from '../views/Jsjlr.vue';
import Kycg from '../views/Kycg.vue';
import Swyy from '../views/Swyy.vue';
import ProductDetail from '../views/ProductDetail.vue';
import Bdtcl from '../views/Bdtcl.vue';
import Zxfw from '../views/Zxfw.vue';
import Hpkf from '../views/Hpkf.vue';
import Kjjlzx from '../views/Kjjlzx.vue';
import Ryzz from '../views/Ryzz.vue';
import Xwzx from '../views/Xwzx.vue';
import Xwxq from '../views/Xwxq.vue';
import Gnyzzx from '../views/Gnyzzx.vue';
import Qyxq from '../views/Qyxq.vue';
import Jmjl from '../views/Jmjl.vue';
import Zszx from '../views/Zszx.vue';
import Jyjczx from '../views/Jyjczx.vue';
import Stsg from '../views/Stsg.vue';
import Gpyq from '../views/Gpyq.vue';
import Gmjt from '../views/Gmjt.vue';
import Gsjj from '../views/gsjj.vue';
import Jgsz from '../views/jgsz.vue';
import Lxwm from '../views/Lxwm.vue';
import Zscq from '../views/Zscq.vue';
import Cyhd from '../views/Cyhd.vue';
import CyhdDetail from '../views/CyhdDetail.vue';
import Zccx from '../views/Zccx.vue';
import Product from '../views/Product.vue';
import Cxcyqy from '../views/Cxcyqy.vue';
import CxcyqyDetail from '../views/CxcyqyDetail.vue';
import Dqly from '../views/Dqly.vue';
import DqlyList from '../views/DqlyList.vue';
import DqlyDetail from '../views/DqlyDetail.vue';
import RzApply from '../views/RzApply.vue';
import NewsList from '../views/NewsList.vue';

const routes: Array<any> = [
  {
    path: '/',
    name: 'home',
    component: Index,
  },
  // 投融资服务
  {
    path: '/trzfw',
    name: 'Trzfw',
    component: Trzfw,
  },
  // 智慧园区
  {
    path: '/zhyq',
    name: 'Zhyq',
    component: Zhyq,
  },
  // 我要入驻
  {
    path: '/wyrz',
    name: 'Wyrz',
    component: Wyrz,
  },
  // 入驻申请
  {
    path: '/rzapply',
    name: 'RzApply',
    component: RzApply,
  },
  // 成果转移
  {
    path: '/cgzy',
    name: 'Cgzy',
    component: Cgzy,
  },
  // 创业导师
  {
    path: '/cyds',
    name: 'Cyds',
    component: Cyds,
  },
  // 创业导师详情
  {
    path: '/cyds/:id',
    name: 'CydsDetail',
    component: CydsDetail,
  },
  // 技术经理人
  {
    path: '/jsjlr',
    name: 'Jsjlr',
    component: Jsjlr,
  },
  // 科研成果
  {
    path: '/kycg',
    name: 'Kycg',
    component: Kycg,
  },
  // 生物医药
  {
    path: '/swyy',
    name: 'Swyy',
    component: Swyy,
  },
  // 产品详情（通用）
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail,
  },
  // 半导体测量
  {
    path: '/bdtcl',
    name: 'Bdtcl',
    component: Bdtcl,
  },
  // 咨询服务
  {
    path: '/zxfw',
    name: 'Zxfw',
    component: Zxfw,
  },
  // 湖畔咖啡
  {
    path: '/hpkf',
    name: 'Hpkf',
    component: Hpkf,
  },
  // 科技交流中心
  {
    path: '/kjjlzx',
    name: 'Kjjlzx',
    component: Kjjlzx,
  },
  // 荣誉资质
  {
    path: '/ryzz',
    name: 'Ryzz',
    component: Ryzz,
  },
  // 新闻中心
  {
    path: '/xwzx',
    name: 'Xwzx',
    component: Xwzx,
  },
  // 新闻详情
  {
    path: '/xwxq/:id',
    name: 'Xwxq',
    component: Xwxq,
  },
  // 概念验证中心
  {
    path: '/gnyzzx',
    name: 'Gnyzzx',
    component: Gnyzzx,
  },
  // 企业需求
  {
    path: '/qyxq',
    name: 'Qyxq',
    component: Qyxq,
  },
  // 精密计量
  {
    path: '/jmjl',
    name: 'Jmjl',
    component: Jmjl,
  },
  // 中试中心
  {
    path: '/zszx',
    name: 'Zszx',
    component: Zszx,
  },
  // 检验检测中心
  {
    path: '/jyjczx',
    name: 'Jyjczx',
    component: Jyjczx,
  },
  // 省图书馆
  {
    path: '/stsg',
    name: 'Stsg',
    component: Stsg,
  },
  // 光谱仪器
  {
    path: '/gpyq',
    name: 'Gpyq',
    component: Gpyq,
  },
  // 光密镜头
  {
    path: '/gmjt',
    name: 'Gmjt',
    component: Gmjt,
  },
  // 公司简介
  {
    path: '/gsjj',
    name: 'Gsjj',
    component: Gsjj,
  },
  // 机构设置
  {
    path: '/jgsz',
    name: 'Jgsz',
    component: Jgsz,
  },
  // 联系我们
  {
    path: '/lxwm',
    name: 'Lxwm',
    component: Lxwm,
  },
  // 知识产权
  {
    path: '/zscq',
    name: 'Zscq',
    component: Zscq,
  },
  // 创业活动
  {
    path: '/cyhd',
    name: 'Cyhd',
    component: Cyhd,
  },
  // 创业活动详情
  {
    path: '/cyhd/:id',
    name: 'CyhdDetail',
    component: CyhdDetail,
  },
  // 政策查询
  {
    path: '/zccx',
    name: 'Zccx',
    component: Zccx,
  },
  // 产品列表
  {
    path: '/product',
    name: 'Product',
    component: Product,
  },
  // 创新创业企业
  {
    path: '/cxcyqy',
    name: 'Cxcyqy',
    component: Cxcyqy,
  },
  // 创新创业企业详情
  {
    path: '/cxcyqy/:id',
    name: 'CxcyqyDetail',
    component: CxcyqyDetail,
  },
  // 党群园地
  {
    path: '/dqly',
    name: 'Dqly',
    component: Dqly,
  },
  // 党群园地列表
  {
    path: '/dqlyList',
    name: 'DqlyList',
    component: DqlyList,
  },
  // 党群园地详情
  {
    path: '/dqlyDetail/:id',
    name: 'DqlyDetail',
    component: DqlyDetail,
  },
  // 新闻列表
  {
    path: '/newslist',
    name: 'NewsList',
    component: NewsList,
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import(/* webpackChunkName: "about" */ '../views/Invite.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to: any, from: any, savedPosition: any) {
    if (savedPosition) {
      return savedPosition;
    }
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ top: 0, left: 0, behavior: 'instant' });
      }, 50);
    });
  },
});

export default router;
